export const MEASUREMENT_STATUS_TO_SEND = 1;
export const MEASUREMENT_STATUS_IN_PROGRESS = 2;
export const MEASUREMENT_STATUS_COMPLETED = 3;
export const MEASUREMENT_STATUS_DOSEMETER_LOST = 4;

function getMeasurementStatusDescription(status, translations) {
  switch (status) {
    case MEASUREMENT_STATUS_TO_SEND:
      return translations.measurementStatusToSend;
    case MEASUREMENT_STATUS_IN_PROGRESS:
      return translations.measurementStatusInProgress;
    case MEASUREMENT_STATUS_COMPLETED:
      return translations.measurementStatusCompleted;
      case MEASUREMENT_STATUS_DOSEMETER_LOST:
        return translations.measurementStatusDosemeterLost;
    default:
      return translations.statusUnknown;
  }
}

export default getMeasurementStatusDescription;
